export default "__VITE_ASSET__Cghs4F71__"